import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import VehicleForm from '../../../components/forms/VehicleForm/VehicleForm';
import './EditVehicle.css';

const EditVehicle = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <Container fluid>
            <div className="edit-vehicle-page mt-5 mb-4">
                <div className="d-flex align-items-center gap-3">
                    <Button
                        variant="outline-secondary"
                        onClick={() => navigate('/vehicle-management')}
                    >
                        Back
                    </Button>
                    <h3 className="mb-0">Edit Vehicle</h3>
                </div>
            </div>
            <VehicleForm
                vehicleId={id}
                isEditMode={true}
            />
        </Container>
    );
};

export default EditVehicle;
